import { useTranslation } from "react-i18next";
import React, { useRef, useState } from "react";
import { Upload, CheckCircle2, Loader2 } from "lucide-react";
import { apiClient, formatApiError } from "@/lib/api";
import { toast } from "sonner";

/** Upload d'un document (photo) vers /api/candidatures/uploads — public, sans compte.
 * Composant partagé par les formulaires de candidature (restaurant, livreur). */
export const DocUpload = ({ label, value, onUploaded, error, testid, hint }) => {
  const { t } = useTranslation();
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const pick = () => inputRef.current?.click();

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await apiClient.post("/candidatures/uploads", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onUploaded(data.url);
      toast.success(t("docu.sent"));
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <span className="text-xs uppercase tracking-widest text-mute block mb-2">{label}</span>
      <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp,application/pdf,.pdf" onChange={onFile} className="hidden" data-testid={`${testid}-input`} />
      <button type="button" onClick={pick} disabled={uploading} data-testid={testid}
        className={`w-full rounded-xl border-2 border-dashed px-3 py-4 text-sm font-medium flex flex-col items-center gap-1.5 transition-colors ${
          value ? "border-brand-green bg-[#E7F6EE] text-brand-green"
            : error ? "border-brand-red bg-[#FFF5F6] text-brand-red"
            : "border-sand bg-white text-mute hover:border-brand-red hover:text-brand-red"
        }`}>
        {uploading ? <Loader2 className="w-5 h-5 animate-spin" />
          : value ? <CheckCircle2 className="w-5 h-5" />
          : <Upload className="w-5 h-5" />}
        {uploading ? t("docu.sending") : value ? t("docu.replace") : t("docu.add")}
      </button>
      <span className="text-xs text-mute mt-1 block">{t("docu.hint")}{hint && !error ? ` — ${hint}` : ""}</span>
      {error && <span className="text-xs text-brand-red mt-1 block">{error}</span>}
    </div>
  );
};
